import { IAcademicYear } from "./academic-year.interface";
import { ISchool } from "./school.interface";
import { ISemester } from "./semester";
import { ISequence } from "./sequence";

export interface IUser {
    created_at: any;
    username?: string;
    owner_id: number;
    email?: string;
    password?: string;
    id?: number;
    sign_in_type: string;
    last_login: string;
    last_login_Ip: string;
    last_login_location: string;
    first_name: string;
    last_name: string;
    phone_number: string,
    address: string,
    about: string;
    gender: string;
    status: UserAccountStatus;
    role: any;
    refresh_token: string;
    permissions: string[]
    userType: string;
    app_user_Id: any;
    x_api_key: string;
    academicYear: IAcademicYear;
    academic_year_id?: number;
    semester?: ISemester;
    semester_id?: number;
    sequence?: ISequence;
    sequence_id?: number;
    remember?: boolean,
    profile_photo: string,
    school: ISchool;
    school_id?: number;
    date_of_birth: string;
}

export type UserType = {
    admin: "ADMIN",
    teacher: "STAFF",
    learner: "LEARNER"
}

export enum UserRole {
    admin = "ADMIN",
    learner = "LEARNER",
    staff = "STAFF",
    admin_staff = "ADMINSTAFF",
    super_admin = "SUPERADMIN"
};

export enum UserAccountStatus {
    ACTIVE = "ACTIVE",
    PENDING_APPROVAL = "PENDING_APPROVAL",
    SUSPENDED = "SUSPENDED",
    REMOVED = "REMOVED",
    GRADUATED = "GRADUATED"
}
